<template>
  <div class="main">
    <app-header v-bind="headerConfig"></app-header>
    <div class="content">
      <div>{{chapterList}}</div>
      <p class="chapter-num elli">章节{{chapterList.length}}</p>

      <input type="text" placeholder="请输入本章节的名称" class="set-option chapter-name" v-if="chapterList.length > 0">
      <input type="text" class="set-option chapter-name" v-model="chapter.name" v-else>

      <div class="material set-option" @click="openLibrary(imageLibrary)">
        {{oldChapter.bgName ===''? '请选择当前章节的背景图': oldChapter.bgName}}
      </div>
      <div class="material set-option" @click="openLibrary(musicLibrary)">
        {{chapterSet.musicName ===''? '请选择当前章节的背景音乐': chapterSet.musicName}}
      </div>

      <div class="set-option add-role-container">
        <span>请选择当前章节的登场角色</span>
        <ul class="role-container clearfix">
          <li class="role-list">
            <a href="javascript:;" class="role-pic aside">
              <img src="../../static/image/aside_role.png" alt="">
            </a>
            <p class="role-name elli">旁白</p>
          </li>
          <li class="role-list" @click="addStageRole('main')">
            <template v-if="stageRoles.main.length <= 0">
              <a href="javascript:;" class="role-pic"></a>
              <p class="role-name elli">配置主角</p>
            </template>
            <template v-else>
              <a href="javascript:;" class="role-pic">
                <img :src="stageRoles.main[0].src" :alt="stageRoles.main[0].name">
              </a>
              <p class="role-name elli">{{stageRoles.main[0].name}}</p>
            </template>
          </li>

          <li v-for="role in stageRoles.costar" @click="addStageRole('costar')"
              class="role-list">
            <a href="javascript:;" class="role-pic">
              <img :src="role.src" :alt="role.name">
            </a>
            <p class="role-name elli">{{role.name}}</p>
          </li>
          <li class="role-list" @click="addStageRole('costar')">
            <a href="javascript:;" class="role-pic"></a>
            <p class="role-name elli">配置配角</p>
          </li>
        </ul>
      </div>

      <div class="btn-container">
        <a href="javascript:;" class="btn fl" @click="close">取消</a>
        <a href="javascript:;" class="btn fr" @click="saveChapter">确定</a>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapState} from 'vuex'
  import store from '../store/store'
  import AppHeader from '../components/header'
  import roleList from '../components/role_list'
  import {ComponentName, Methods} from '../const/common'

  export default {
    name: 'change_chapter',
    components: {
      'app-header': AppHeader/*,
      'role-list': roleList,*/
    },
    computed: {
      ...mapState(['chapterList', 'chapterSet', 'stageRoles', 'parrent', 'editChapter'])
    },
    data () {
      return {
        headerConfig: {
          title: '章节设置',
          isStoryMenu: false,
          backNote: '角色列表',
          closeModule: ComponentName.CHANGE_CHAPTER
        },
        imageLibrary: ComponentName.IMAGE_LIBRARY,
        musicLibrary: ComponentName.MUSIC_LIBRARY,
        roleListType: {
          type: 'editStory',
          status: ''
        },
        oldChapter: this.chapterList[this.editChapter === ''? 0: this.editChapter],
        chapter: {
          name: this.oldChapter.name
        },
        protagonistDetail: {},
        costarDetail: [],
      }
    },
    store,
    methods: {
      close () {
        Methods.cutComponent([ComponentName.CHAPTER_SET], false);
      },
      openLibrary (type) {
        Methods.cutComponent([type], true);
      },
      addStageRole (type) {
        this.stageRoles.status = type;

        Methods.cutComponent([ComponentName.ROLE_LIST], true);
      },
      saveChapter () {
        let _roles = [], _chapterConfig = this.chapterSet;

        _roles.push(this.stageRoles.main[0].name);
        for (let i in this.stageRoles.costar) {
          _roles.push(this.stageRoles.costar[i].name);
        }

        Middle.MiddleData.AddChapter(this.chapter.name, _chapterConfig.bgSrc, _chapterConfig.musicSrc, this.parrent.createPattern, _roles);
        Methods.cutComponent([ComponentName.CHAPTER_SET, ComponentName.EDIT_STORY_ROLE], false);
        Methods.cutComponent([ComponentName.EDIT_STORY], true);
        Methods.clearStageRoleSign();
      }
    }
  }
</script>

<style scoped>
  @import "../style/css/chapters_set.css";
</style>



// WEBPACK FOOTER //
// src/components/change_chapters_set.vue